import { render, staticRenderFns } from "./overviewProfitlist.vue?vue&type=template&id=0ba8dc33&scoped=true"
import script from "./overviewProfitlist.vue?vue&type=script&lang=js"
export * from "./overviewProfitlist.vue?vue&type=script&lang=js"
import style0 from "./overviewProfitlist.vue?vue&type=style&index=0&id=0ba8dc33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8dc33",
  null
  
)

export default component.exports